import { Link } from "react-router-dom";
import type { MediaItem } from "@/lib/types";
import { typeLabel } from "@/lib/catalog";

interface MovieCardProps {
  item: MediaItem;
  rank?: number;
}

export default function MovieCard({ item, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex w-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 海报`}
          title={`${item.title} - 金桔影院`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-background-950/70 px-2 py-0.5 text-xs font-semibold text-background-50 backdrop-blur-sm">
          {typeLabel(item.type)}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-full bg-primary-500 px-2 py-0.5 text-xs font-bold text-background-50">
          <i className="ri-star-fill text-[11px]"></i>
          {item.rating.toFixed(1)}
        </span>
        {typeof rank === "number" && (
          <span className="absolute bottom-0 left-0 flex h-8 w-8 items-center justify-center rounded-tr-lg bg-accent-500 font-heading text-sm font-extrabold text-background-50">
            {rank}
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 translate-y-full bg-gradient-to-t from-background-950/85 to-transparent px-3 pb-3 pt-8 transition-transform duration-300 group-hover:translate-y-0">
          <p className="line-clamp-2 text-xs leading-relaxed text-background-100">{item.synopsis}</p>
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-3">
        <h3 className="line-clamp-1 font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {item.title}
        </h3>
        <div className="flex flex-wrap items-center gap-1.5">
          {item.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-800"
            >
              {genre}
            </span>
          ))}
        </div>
        <p className="mt-auto flex items-center gap-1 text-xs text-foreground-500">
          <i className="ri-calendar-line"></i>
          {item.year}
          <span className="mx-0.5">·</span>
          {item.region}
        </p>
      </div>
    </Link>
  );
}